import TeamHeaderContainer from './TeamHeaderContainer';

export default TeamHeaderContainer;
